import { useEffect, useState } from 'react';

/**
 * Keeps a modal mounted through exit animation.
 * `open` — desired state; `mounted` — render; `visible` — add CSS class `is-open`.
 */
export function useAnimatedModal(open: boolean, durationMs = 240): {
  mounted: boolean;
  visible: boolean;
} {
  const [mounted, setMounted] = useState(open);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setMounted(true);
      const id = window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => setVisible(true));
      });
      return () => window.cancelAnimationFrame(id);
    }

    setVisible(false);
    const t = window.setTimeout(() => setMounted(false), durationMs);
    return () => window.clearTimeout(t);
  }, [open, durationMs]);

  return { mounted, visible };
}
